export const REQUEST_BANK_ACCOUNT = 'REQUEST_BANK_ACCOUNT';
export const IMPORT_BANK_ACCOUNT = 'IMPORT_BANK_ACCOUNT';
export const DELETE_BANK_ACCOUNT = 'DELETE_BANK_ACCOUNT';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const REQUEST_DEBIT_CARD = 'REQUEST_DEBIT_CARD';
export const ADD_DEBIT_CARD = 'ADD_DEBIT_CARD';
export const DELETE_DEBIT_CARD = 'DELETE_DEBIT_CARD';
export const UPDATE_DEBIT_CARD = 'UPDATE_DEBIT_CARD';
export const UPDATE_DEBIT_CARD_START = 'UPDATE_DEBIT_CARD_START';
export const UPDATE_DEBIT_CARD_ERROR = 'UPDATE_DEBIT_CARD_ERROR';
export const SET_MERCHANT_INFO = 'SET_MERCHANT_INFO';
export const FETCH_BALANCE = 'FETCH_BALANCE';
export const INITIATE_INSTANT_PAYOUT = 'INITIATE_INSTANT_PAYOUT';
export const FETCH_SUBSCRIPTION_PAYMENT_CARD = 'FETCH_SUBSCRIPTION_PAYMENT_CARD';
export const UPDATE_SUBSCRIPTION_PAYMENT_CARD = 'UPDATE_SUBSCRIPTION_PAYMENT_CARD';
